import React from 'react';
import Hamburger from '../components/Hamburger';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import '../../sass/components/_header.scss';

import cartImage from '../../static/images/cart.svg';

const Header = (props) => (
  <header className="header">
    <Hamburger handleClick={props.menuClick} isMenuVisible={props.isMenuVisible} />
    <p>{props.title}<span>{props.subtitle}</span></p>
    <OutboundLink href="#" className="snipcart-checkout snipcart-summary">
      <img src={cartImage} alt="cart" />
      <span className="snipcart-total-items" />
    </OutboundLink>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js